module.exports = {
  footerText: `Copyright © ${new Date().getFullYear()} Libre Opción`
};
